module.exports = __webpack_public_path__ + "img/hero_formsplit.e9aeb439.png";